import React, { useEffect, useState } from 'react';
import { Button, Input } from 'components';
import { useFormContext } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateUserInfoField,
  userInfoSelector,
} from 'redux/slices/profile/UserInfoSlice';
import { isUserCompanySelector } from 'redux/slices/signUp/signUpSlice';

const UserInfoForm = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(userInfoSelector);
  const isUserCompany = useSelector(isUserCompanySelector);

  const { formState, setValue } = useFormContext();
  const { errors } = formState;

  useEffect(() => {
    setValue('fullName', userInfo?.fullName);
    setValue('identityNumber', userInfo?.identityNumber);
    setValue('taxNumber', userInfo?.taxNumber);
    setValue('telephone', userInfo?.telephone);
    setValue('email', userInfo?.email);
    setValue('username', userInfo?.username);
    setValue('companyName', userInfo?.companyName);
  }, [userInfo]);

  const [formErrors, setFormErrors] = useState({});
  useEffect(() => setFormErrors({ ...errors }), [errors]);

  const handleChangeUserInfo = (field, value) => {
    dispatch(updateUserInfoField({ field, value }));
  };
  return (
    <>
      <div className="text-large text-primary font-bold text-center">
        Hesap Bilgileri
      </div>
      <div className="w-96">
        <div className="p-4">
          <Input
            maxLength={200}
            className="w-auto text-center"
            label="Adı Soyadı"
            name="fullName"
            id="fullName"
            value={userInfo.fullName}
            onChange={(e) =>
              handleChangeUserInfo(e.target.name, e.target.value)
            }
            errors={formErrors?.fullName?.message}
          />
        </div>
        <div className={`${isUserCompany ? 'hidden' : 'visible'} p-4`}>
          <Input
            className="w-auto text-center"
            label="TC Kimlik Numarası"
            value={userInfo.identityNumber}
            maxLength={11}
            type="number"
            max="99999999999"
            name="identityNumber"
            onChange={(e) =>
              !isNaN(e.target.value) &&
              handleChangeUserInfo(e.target.name, Math.abs(e.target.value))
            }
            errors={formErrors?.identityNumber?.message}
          />
        </div>
        <div className={`${isUserCompany ? 'visible' : 'hidden'} p-4`}>
          <Input
            className="w-auto text-center"
            label="Vergi Numarası"
            value={userInfo.taxNumber}
            maxLength={11}
            type="text"
            name="taxNumber"
            onChange={(e) =>
              !isNaN(e.target.value) &&
              handleChangeUserInfo(e.target.name, Math.abs(e.target.value))
            }
            errors={formErrors?.taxNumber?.message}
          />
        </div>
        <div className="p-4">
          <Input
            className="w-auto text-center"
            label="Şirket Adı"
            value={userInfo.companyName}
            type="text"
            name="companyName"
            onChange={(e) =>
              handleChangeUserInfo(e.target.name, e.target.value)
            }
            errors={formErrors?.companyName?.message}
          />
        </div>
        <div className="p-4">
          <Input
            className="w-auto text-center"
            label="Telefon Numarası"
            value={userInfo.telephone}
            type="number"
            name="telephone"
            maxLength={25}
            onChange={(e) =>
              e.target.value.length <= 11 &&
              handleChangeUserInfo(e.target.name, Math.abs(e.target.value))
            }
            errors={formErrors?.telephone?.message}
          />
        </div>
        <div className="p-4">
          <Input
            className="w-auto text-center"
            label="E-mail Adresi"
            type="text"
            name="email"
            value={userInfo.email}
            onChange={(e) =>
              handleChangeUserInfo(e.target.name, e.target.value.replace(/\s/g, ''))
            }
            errors={formErrors?.email?.message}
          />
        </div>
        <div className="p-4">
          <Input
            className="w-auto text-center"
            label="Kullanıcı Adı"
            value={userInfo.username}
            type="text"
            name="username"
            onChange={(e) =>
              handleChangeUserInfo(
                e.target.name,
                e.target.value.replace(/\s/g, '').toLocaleLowerCase('TR')
              )
            }
            errors={formErrors?.username?.message}
          />
        </div>
      </div>
      <Button
        className=" bg-primary "
        buttonTextClass="text-white"
        text="Kaydet"
        type="submit"
      />
    </>
  );
};

export default UserInfoForm;
